import React, { useState, useMemo } from 'react';
import { TrendingUp } from 'lucide-react';

const UTILIZATION = 0.62;
const HOURS_PER_DAY = 6;

export function RevenueEstimator() {
  const [pitchCount, setPitchCount] = useState(2);
  const [hourlyPrice, setHourlyPrice] = useState(300);

  const monthly = useMemo(
    () => Math.round(pitchCount * hourlyPrice * HOURS_PER_DAY * 30 * UTILIZATION),
    [pitchCount, hourlyPrice]
  );

  return (
    <div className="rounded-2xl border border-white/10 bg-[#1E2D4A] p-6" data-testid="revenue-calculator">
      <div className="mb-1 flex items-center gap-2">
        <TrendingUp className="h-5 w-5 text-teal-300" />
        <h3 className="text-lg font-bold text-white">احسب الدخل المتوقع من ملاعبك</h3>
      </div>
      <p className="mb-5 text-xs text-slate-400">حرّك المؤشرات وشاهد الفرق الذي يصنعه الحجز الذكي على أرباحك الشهرية</p>

      <div className="space-y-5">
        <div>
          <div className="mb-1.5 flex justify-between text-xs font-semibold text-slate-300">
            <span>عدد الملاعب</span><span className="text-teal-300">{pitchCount}</span>
          </div>
          <input
            type="range" min={1} max={10} value={pitchCount}
            onChange={(e) => setPitchCount(Number(e.target.value))}
            data-testid="revenue-slider-pitch-count"
            className="w-full accent-teal-400"
          />
        </div>
        <div>
          <div className="mb-1.5 flex justify-between text-xs font-semibold text-slate-300">
            <span>سعر الساعة (ر.س)</span><span className="text-teal-300">{hourlyPrice}</span>
          </div>
          <input
            type="range" min={100} max={600} step={10} value={hourlyPrice}
            onChange={(e) => setHourlyPrice(Number(e.target.value))}
            data-testid="revenue-slider-hourly-price"
            className="w-full accent-teal-400"
          />
        </div>
      </div>

      <div className="mt-6 rounded-xl border border-teal-400/30 bg-teal-400/10 p-4 text-center">
        <p className="text-xs text-teal-200">دخل شهري تقديري إضافي</p>
        <p dir="ltr" className="mt-1 text-3xl font-extrabold text-teal-300" data-testid="revenue-estimate-output">
          {monthly.toLocaleString('en-US')} <span className="text-base font-semibold">ر.س</span>
        </p>
      </div>
    </div>
  );
}
